"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REMOTES = void 0;
/**
 * Make sure the value of each enumerated key exactly matches the subdomain of your
 * federated microsite.
 */
var REMOTES;
(function (REMOTES) {
    REMOTES["WORKSPACES"] = "looker_workspaces";
    REMOTES["LIFT_STATIONS"] = "lift_stations";
    REMOTES["DASHBOARD"] = "dashboard";
    REMOTES["SUMMARYZE"] = "summaryze";
    REMOTES["ADMIN"] = "admin";
    REMOTES["INNO_MAP"] = "inno_map";
    REMOTES["MAP"] = "map";
    REMOTES["MAP_COMPONENTS"] = "map_components";
    REMOTES["TOOLS"] = "tools";
    // TODO: Remove this after it's replaced by AM_DATA_MANAGEMENT in all usages across all repos
    REMOTES["AM_ASSET_UPLOAD"] = "app_am_upload";
    REMOTES["AM_DATA_MANAGEMENT"] = "app_am_data_management";
    REMOTES["AM_ACTIVITIES"] = "app_am_activities";
    REMOTES["AM_ASSETS"] = "app-am-assets";
    REMOTES["AM_INSPECTIONS"] = "inspections";
    REMOTES["AM_MAIN"] = "asset";
    REMOTES["AM_REHAB"] = "am-rehab-decision-dashboard";
    REMOTES["AM_RISK"] = "app-am-risk";
    REMOTES["AM_COMMON"] = "lib_am_common";
    REMOTES["USER_MANAGEMENT"] = "user_management";
    REMOTES["MODEL_FACTORY"] = "model_factory";
    REMOTES["ALERTS_MANAGEMENT"] = "alerts";
    REMOTES["INCIDENT_MANAGEMENT"] = "incident";
    REMOTES["IMPACT_SIMULATIONS"] = "impact_simulations";
})(REMOTES || (exports.REMOTES = REMOTES = {}));
